import { render } from "./account-settings-password.vue?vue&type=template&id=5a6afa92&scoped=true&ts=true"
import script from "./account-settings-password.vue?vue&type=script&lang=ts"
export * from "./account-settings-password.vue?vue&type=script&lang=ts"

import "./account-settings-password.vue?vue&type=style&index=0&id=5a6afa92&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6afa92"]])

export default __exports__